import React from 'react';
import styled from 'styled-components';
import { ArrowRight, Database, TrendingUp, Cloud } from 'lucide-react';

const HeroSection = styled.section`
  id: home;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding-top: 80px;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
    padding: 0 1rem;
  }
`;

const HeroContent = styled.div`
  h1 {
    font-size: 3.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    line-height: 1.6;
    opacity: 0.9;
  }
`;

const CTAButton = styled.button`
  background-color: #ff6900;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e55a00;
    transform: translateY(-2px);
  }
`;

const HeroVisual = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
`;

const IconCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  svg {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #ff6900;
  }

  h3 {
    font-size: 1.1rem;
    margin: 0;
  }
`;

const Hero: React.FC = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <HeroSection id="home">
      <Container>
        <HeroContent>
          <h1>Transform Your Data Into Strategic Advantage</h1>
          <p>
            Unlock the power of your healthcare and enterprise data with expert data engineering solutions. 
            From pipeline architecture to analytics infrastructure, we build scalable systems that drive results.
          </p>
          <CTAButton onClick={scrollToServices}>
            Explore Our Services <ArrowRight />
          </CTAButton>
        </HeroContent>
        <HeroVisual>
          <IconCard>
            <Database />
            <h3>Data Architecture</h3>
          </IconCard>
          <IconCard>
            <TrendingUp />
            <h3>Analytics</h3>
          </IconCard>
          <IconCard>
            <Cloud />
            <h3>Cloud Solutions</h3>
          </IconCard>
        </HeroVisual>
      </Container>
    </HeroSection>
  );
};

export default Hero;